export default __webpack_public_path__ + "static/media/apple-icon-180x180.12f25db6.png";